import { useEffect } from 'modules/core/hooks/useEffect'

import { ConfirmationModal } from 'modules/integrations/components/SyncButton/Modals/ConfirmationModal'
import { ValidationsModal } from 'modules/integrations/components/SyncButton/Modals/ValidationsModal'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const Modals = () => {
  const {
    syncCompensations,
    syncValidations,
    showModal,
    closeModal,
    refetchSyncValidations,
    syncValidationsLoading,
  } = useIntegrationsSyncContext()

  const syncCompensationsConfirmationClick = async () => {
    syncCompensations()
  }

  useEffect(() => {
    showModal && refetchSyncValidations()
  }, [showModal])

  if (!showModal || syncValidationsLoading) return null
  return (
    <>
      {syncValidations.length > 0 ? (
        <ValidationsModal onClose={closeModal} validations={syncValidations} />
      ) : (
        <ConfirmationModal onClose={closeModal} onSubmit={syncCompensationsConfirmationClick} />
      )}
    </>
  )
}
